import React from 'react';
import { styled } from '@mui/material/styles';
import { Box, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import Tasks from './Tasks';
import * as monitoringSlice from '../../../data/monitoring.slice';
import * as lookupSlice from '../../../data/lookup.slice';
import authService from '../../../services/authService';
import { useAppSelector } from '../../../hooks/useAppSelector';
import { useAppDispatch } from '../../../hooks/useAppDispatch';

const PREFIX = 'HomePage';

const classes = {
  container: `${PREFIX}-container`,
  header: `${PREFIX}-header`,
  title: `${PREFIX}-title`,
  content: `${PREFIX}-content`,
};

const StyledBox = styled(Box)(({ theme }) => ({
  [`&.${classes.container}`]: {
    flexGrow: 1,
    display: 'flex',
    flexDirection: 'column',
  },
  [`& .${classes.header}`]: {
    display: 'flex',
    justifyContent: 'space-between',
    padding: theme.spacing(3),
  },
  [`& .${classes.title}`]: {
    fontFamily: 'Bitter',
    fontWeight: 700,
    fontSize: 30,
  },
  [`& .${classes.content}`]: {
    display: 'flex',
    paddingLeft: theme.spacing(3),
    paddingRight: theme.spacing(3),
  },
}));

export default function HomePage() {
  const { t } = useTranslation('common');
  const dispatch = useAppDispatch();

  const tasks = useAppSelector(monitoringSlice.selectUserTasks);
  const loadingTasks = useAppSelector(monitoringSlice.selectLoadingUserTasks);

  React.useEffect(() => {
    // TODO: this needs to send the logged in user id once we call the /users/me endpoint at app startup
    dispatch(monitoringSlice.fetchUserTasksAsync('1'));
    dispatch(lookupSlice.fetchLookupItemsAsync('taskResolveReason'));
    dispatch(lookupSlice.fetchLookupItemsAsync('taskEscalateReason'));
  }, []);

  return (
    <StyledBox className={classes.container}>
      <Box className={classes.header}>
        <Typography variant="h3" className={classes.title}>
          {t('home.tasks')}
        </Typography>
      </Box>
      <Box className={classes.content}>
        <Tasks tasks={tasks} loading={loadingTasks} />
      </Box>
    </StyledBox>
  );
}
